'use client'

import { Layer } from '@dustin-web/styledust/constants'
import React, { MutableRefObject, useEffect, useState } from 'react'
import Popover, { PositionType } from '../popover'

type Props = {
  tooltipText: string
  children?: React.ReactNode
  targetRef?: MutableRefObject<HTMLElement | null>
  className?: string
  style?: React.CSSProperties
  popoverStyle?: React.CSSProperties
  popoverClassName?: string
  popoverLayerClassName?: string
  disable?: boolean
  layer?: Layer
  positions?: PositionType[]
}

export const Tooltip = ({
  tooltipText,
  children,
  targetRef,
  className,
  style,
  popoverStyle,
  popoverClassName,
  popoverLayerClassName,
  disable = false,
  layer,
  positions = ['bottom-free'],
}: Props) => {
  const [popoverOpen, setPopoverOpen] = useState(true)

  useEffect(() => {
    if (!disable) setPopoverOpen(false)
  }, [disable])

  return (
    <Popover
      tooltip
      targetRef={targetRef}
      open={disable ? false : popoverOpen}
      onToggle={x => setPopoverOpen(x)}
      content={tooltipText}
      className={className}
      positions={positions}
      style={style}
      popoverStyle={popoverStyle}
      popoverClassName={popoverClassName}
      popoverLayerClassName={popoverLayerClassName}
      closeOnOutsideClick={true}
      layer={layer}>
      {children}
    </Popover>
  )
}

export default Tooltip
